import styled from 'styled-components'

export const CommentBlock = styled.div`
  padding: 15px 24px;
  min-height: 140px;
  border-radius: 8px;
  background-color: white;
  border-top: 1px solid #f0f0f0;
  box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;
`

export const FormButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 10px 0 20px;
`
export const UploadWrapper = styled.span`
  margin: 0 4px;
  position: relative;

  .ant-upload-list {
    position: absolute;
  }
`

export const MessageWrapper = styled.div`
  padding: 8px;
  margin-top: 10px;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-weight: bold;
  }
`

export const UploadFileListWrapper = styled.ul`
  margin: 10px 0 15px;
  padding-left: 0 !important;
`
